import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';
import isEqual from 'lodash/isEqual';
export default {
  name: 'NiotaClassicGwMgmtAlertConfigs',
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      formValid: false,
      unsavedPrompt: false,
      mailBridges: [],
      isLoading: true,
      alertConfigs: [],
      deletedConfigs: [],
      savedAlertConfigs: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    formCardButtons: function formCardButtons() {
      return [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    }
  }),
  watch: {},
  mounted: function mounted() {
    this.findAlertConfigs();
    this.savedAlertConfigs = cloneDeep(this.alertConfigs);
  },
  methods: {
    findAlertConfigs: function findAlertConfigs() {
      var _this2 = this;

      Promise.all([ApiService.bridgesGetPlainConfigs('mail'), ApiService.gwMgmtFindAlertConfigs()]).then(function (res) {
        _this2.mailBridges = res[0].map(function (mb) {
          return _objectSpread(_objectSpread({}, mb), {}, {
            uiTitle: "".concat(mb.name, " (").concat(_this2.$i18n_t('Common.tenantId'), ": ").concat(mb.tenantId, ")")
          });
        });
        _this2.alertConfigs = res[1];
        _this2.isLoading = false;
        _this2.savedAlertConfigs = cloneDeep(_this2.alertConfigs);
      }).catch(function (error) {
        _this2.$snack(_this2.$i18n_t('NiotaClassic.GWMonitoring.snacks.errorGatewayDevice'), 'error');

        console.error(error);
      });
    },
    addNewAlert: function addNewAlert(index) {
      this.alertConfigs.splice(index + 1, 0, {
        userId: this.$store.state.authentication.user.id,
        email: this.$store.state.authentication.user.email,
        properties: {
          emailSubject: this.$i18n_t('NiotaClassic.GWMonitoring.alertForm.mailSubjectTemplate'),
          emailBody: this.$i18n_t('NiotaClassic.GWMonitoring.alertForm.mailBodyTemplate')
        }
      });
      this.alertConfigs = cloneDeep(this.alertConfigs);
    },
    removeAlert: function removeAlert(index) {
      this.deletedConfigs.push(this.alertConfigs[index]);
      pullAt(this.alertConfigs, [index]);
      this.alertConfigs = cloneDeep(this.alertConfigs);
    },
    closeHook: function closeHook() {
      if (!isEqual(this.alertConfigs, this.savedAlertConfigs)) {
        this.unsavedPrompt = true;
        return;
      }

      this.$emit('close');
    },
    saveAlerts: function saveAlerts() {
      var _this3 = this;

      if (this.alertConfigs.length === 0 && this.deletedConfigs.length === 0) {
        this.$emit('close');
        return;
      }

      ApiService.gwMgmtUpdateAlertConfigs({
        configs: this.alertConfigs,
        delete: this.deletedConfigs.filter(function (c) {
          return (c || {}).id;
        })
      }).then(function () {
        _this3.savedAlertConfigs = cloneDeep(_this3.alertConfigs);

        _this3.$snack(_this3.$i18n_t('NiotaClassic.GWMonitoring.snacks.alertConfigSuccess'), 'success');
      }).catch(function (error) {
        _this3.$snack(_this3.$i18n_t('NiotaClassic.GWMonitoring.snacks.alertConfigFailed'), 'error');

        console.error(error);
      });
    }
  }
};